import { apiSlice } from '@services/apiSlice';
import { Footer as endpoints } from '@services/endpoints';
import { Footer } from './Footer.types';

interface FooterResponse {
  FooterModel: Footer;
  I18n: Record<string, string>;
}

interface FooterData {
  footer: Footer;
  i18n: Record<string, string>;
}

const footerApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    fetchFooter: build.query<FooterData, void>({
      query: () => ({
        url: endpoints.fetchFooter + '/' + window.lang,
      }),
      transformResponse(baseQueryReturnValue: FooterResponse) {
        return {
          footer: baseQueryReturnValue.FooterModel,
          i18n: baseQueryReturnValue.I18n,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useFetchFooterQuery } = footerApi;
